import React from 'react';
import ReactDOM from 'react-dom';
import RoutesPage from './routes/Routes';


ReactDOM.render(
  <React.StrictMode>
    <RoutesPage />
  </React.StrictMode>,
  document.getElementById('root')
);

